<template>
  <div class="wrapper">
    <div v-for="(item,index) in orderInfo.items" :key="index" class="shop-item">
      <div class="box">
        <span class="label">商品</span>
        <div class="shop-box">
          <img :src="item.image_url" :alt="item.name" class="shop-img">
          <div class="shop-info">
            <div class="shop-name">{{item.name}}</div>
            <div class="shop-price">￥{{item.price}}</div>
            <div class="shop-type">{{item.addon}}</div>
          </div>
        </div>
      </div>
      <div class="box">
        <span class="label">商品评分</span>
        <div class="shop-box" v-show="item.id">
          <el-rate :value="score[item.id]" show-text @change="(value)=>changeScore(value,item.id)"></el-rate>
        </div>
      </div>
      <div class="box">
        <span class="label">评价晒单</span>
        <div class="shop-box">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="分享体验心得((最多500字))"
            v-model="textarea[item.id]"
            class="textarea"
          ></el-input>
        </div>
      </div>
      <div class="box">
        <span class="label">上传图片</span>
        <div class="shop-box">
          <el-upload
            :action="upLoadUrl"
            list-type="picture-card"
            :limit="5"
            :on-remove="(file,fileList)=> handleRemove(file,fileList,item.id)"
            :http-request="e=>handleUpload(e,item.id)"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt>
          </el-dialog>
        </div>
      </div>
    </div>

    <div class="submit" @click="toEvaluate">发表评价</div>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
export default {
  name: "Evaluate",
  components: {},
  props: {},
  data() {
    return {
      order_id: "",
      orderInfo: {}, //订单详情
      images: {},
      score: {}, // 商品评价
      textarea: {}, // 商品评价信息
      isupload: {}, // 启/禁用 图片上传按钮
      upLoadUrl: apiBaseUrl + "api.html",
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: []
    };
  },
  watch: {},
  computed: {
    rateValue() {
      return key => {
        return this.score.hasOwnProperty("key") ? this.score[key] : 5;
      };
    }
  },
  methods: {
    changeScore(val, item) {
      this.score[item] = val;
    },
    //评价
    toEvaluate() {
      let items = {};
      let obj = this.images;
      Object.keys(obj).forEach(key => {
        items[key] = {
          images: obj[key],
          score: this.score[key],
          textarea: this.textarea[key]
        };
      });

      let data = {
        order_id: this.order_id,
        items: items
      };
      this.$api.orderEvaluate(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
          this.$router.go(-1);
        }
      });
    },
    getOrderInfo() {
      let data = {
        order_id: this.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status && res.data.text_status === 4) {
          let orderInfo = res.data;

          let images = {};
          let textarea = {};
          let upload = {};
          let score = {};

          orderInfo.items.forEach(item => {
            images[item.id] = [];
            textarea[item.id] = "";
            upload[item.id] = true;
            score[item.id] = 5;
          });
          this.orderInfo = orderInfo;
          this.images = images;
          this.textarea = textarea;
          this.score = score;
          this.isupload = upload;
        } else {
          this.$alert("订单不存在或状态不可评价!", "提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: action => {
              this.$router.go(-1);
            }
          });
        }
      });
    },
    //上传图片
    handleUpload(e, id) {
      var formdata = new FormData();
      formdata.append("upfile", e.file, e.file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          let img = {
            url: res.data.url,
            id: res.data.image_id
          };
          this.images[id].push(img);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    handleRemove(file, fileList,id) {
      // console.log(file);
      // console.log(fileList);
      // console.log(this.images[id]);
      // this.images[id].splice(key, 1)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  created() {},
  mounted() {
    let query = this.$route.query;
    if (query.order_id) {
      this.order_id = query.order_id;
      this.getOrderInfo();
    } else {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .shop-item {
    border-bottom: 1px solid $border;
    padding-top: 20px;
  }
  .box {
    position: relative;
    margin-bottom: 20px;
    .label {
      position: absolute;
      display: block;
      width: 80px;
      top: 0;
      left: 0;
      height: 20px;
      line-height: 20px;
    }
    .shop-box {
      margin-left: 100px;
      display: inline-flex;
      .shop-img {
        width: 80px;
        height: 80px;
        object-fit: contain;
        border: 1px solid $border;
        margin-right: 10px;
      }
      .shop-info {
        font-size: 12px;
        .shop-name {
          color: #757575;
        }
        .shop-price {
          margin: 15px 0;
        }
        .shop-type {
          color: #757575;
        }
      }
      .textarea {
        width: 480px;
        resize: none;
        &:focus {
          outline: none;
          border-color: $theme-color;
        }
      }
    }
  }
}
.submit {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: $theme-color;
  color: #fff;
  margin-left: 100px;
  margin-top: 30px;
  cursor: pointer;
}
</style>